import {
  CommonRequest,
  Method,
  ServiceName,
  CommonResponse,
  DmlResponse,
} from 'models/common/RestApi';
import { SearchParam, UtMatrixRegistHistory } from 'models/ut/UtMatrixRegistHistory';
import { callApi } from 'utils/ApiUtil';

export const getUtMatrixRegistHistoryList = async (searchParam: SearchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/ut/getUtMatrixRegistHistoryList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<UtMatrixRegistHistory[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as UtMatrixRegistHistory[];
};
